import _ from 'lodash'
import { REACT_APP_IMG } from '../../common/config'
import React from 'react'
import moment from 'moment'
import { CAR_NOT_FOUND_THUMB } from '../../common/assets'
import { MELI_DAYS_UNTIL_REFRESH_TOKEN, SALE_TYPE } from '../common/Constants'
import qs from 'query-string'
import { checkPermission } from '../common/hooks/useCheckPermission'
import { PERMISSIONS_MODULES_ACRONYMS } from '../common/Constants'
import imageCarNotFound from '../../images/image_car_not_found.svg'
const MAX_SHAREVALUE = 9999.99
export const MAX_INTEGER_VALUE = 2147483648
const moneyFormatter = new Intl.NumberFormat('es-AR')
const usMoneyFormatter= new Intl.NumberFormat('en-US')
import useMediaQuery from '@material-ui/core/useMediaQuery'

const currentLocale = navigator.languages?.[0] ?? navigator.language

/*
* min: min time in minuts
* max: max time in minuts
*/
export const getRandomTimeInMilliseconds = (min, max) => {
    const minTime = min * 60000
    const maxTime = max * 60000
    return Math.floor(Math.random() * (maxTime - minTime + 1)) + minTime;
}

export const formatNumber = {
    percent: (n, fixed = true) => (fixed ? n.toFixed(2) + '%' : n + '%'),
    money: (n, sign = '$', fixed = true) =>
        fixed
            ? sign.concat(moneyFormatter.format(Number(n).toFixed(2)))
            : sign.concat(moneyFormatter.format(n)),
    moneyWithMinusSymbol: n =>
        n >= 0 ? formatNumber.money(n) : '- ' + formatNumber.money(n * -1),
    roundOut: (n, sign = '$', fixed = true) =>
        fixed
            ? sign.concat(moneyFormatter.format(Number(n).toFixed(2)))
            : sign.concat(moneyFormatter.format(n)),
    separator: n => moneyFormatter.format(n),
    usSeparator: n => usMoneyFormatter.format(n),
    resetMoneySign: n => n.replaceAll(',', '.').replaceAll('.', ''),
    resetPercentSign: n => n.replaceAll(',', '.'),
    truncateTo2ndDecimalPlace: n =>
        n.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
}

export const moneyWithTwoDecimals = cost => {
    let totalCost = 0
    totalCost = formatNumber.money(cost)
    const numberLength = totalCost.length
    const indexOfComa = totalCost.indexOf(',')
    let totalCostToShow = 0

    if (numberLength - indexOfComa !== 3) {
        totalCostToShow = totalCost.concat(0)
    } else {
        totalCostToShow = totalCost
    }

    return totalCostToShow
}

export const verifyIntegerAndSign = n => {
    let numberToShow
    if (n < 0) {
        n = n * -1
    }

    numberToShow = '$' + formatNumber.separator(n)

    if (!Number.isInteger(n)) {
        numberToShow = moneyWithTwoDecimals(n)
    }

    return numberToShow
}

export const formatText = {
    normalizedText: text =>
        text
            ? text
                  .toLowerCase()
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
            : ''
}

export const ACTION_STATE = {
    SUCCESS: 'SUCCESS',
    PENDING: 'PENDING',
    ERROR: 'ERROR'
}

export const notValidateAmount = value => {
    value = formatNumber.resetMoneySign(value)
    if (!value) return true
    if (value < 0 || value > MAX_INTEGER_VALUE) return true
    if (!isNaN(value)) return true
    if (Number(value)) return true
}

export const isValidPositiveInteger = (value, maxValue = MAX_INTEGER_VALUE) => {
    if (value < 0 || value > maxValue) return false
    const rgNum = new RegExp(/^[0-9]+$/g)
    return rgNum.test(value)
}

export const setFormatAmount = value => {
    return formatNumber.separator(formatNumber.resetMoneySign(value.toString()))
}

export const isNumber = value => {
    // eslint-disable-next-line no-useless-escape
    const rgNum = new RegExp(/^([0-9]\d*(\.|\,)\d*|0?(\.|\,)\d*[0-9]\d*|[0-9]\d*)$/gm)
    return rgNum.test(value)
}


export const notValidatePercentage = value => {
    if (removeLeadingZeros(value)) return true
    if (!value.match(/^((100(\.0{1,2})?)|(\d{1,2}(\.\d{1,2})?))$/) == null) return true
    if (Number(value.replaceAll(',', '.')) > 100) return true
    if (!isNumber(value.replaceAll(',', '.'))) return true
    return
}

export const validateNegativeWithTwoDecimals = (value) => {
    // Only allow numbers, a comma, and a negative sign
    if (!/^(-)?(\d+(,\d{0,2})?)?$/.test(value)) {
      return false
    }

    return true
  }

export const validateNegativeWithOneDecimal = (value) => {
  // Only allow numbers, a comma, and a negative sign
  if (!/^(-)?(\d+(,\d{0,1})?)?$/.test(value)) {
    return false
  }
  return true
}

export const validateBetweenNegativeZeroAndHundred = (value) => {
    // Constrain input to between 100 and 0 (inclusive)
    if (parseFloat(value) < -100 || parseFloat(value) > 0) {
      return false
    }

    return true
  }

export const validDepreciation = (value) =>{
    const validateDecimals = !validateNegativeWithTwoDecimals(value)
    const validateBetween = !validateBetweenNegativeZeroAndHundred(value)
    const validateZero = String(value).includes(',') && parseFloat(value) == 0 && !String(value).includes('-')
    return !(validateDecimals || validateBetween || validateZero);
}

export const setFormatPercentage = value => {
    value = value.toString().replaceAll(',', '.')
    value = value >= 1 ? value.replace(/^(0+)/, '') : value
    const valueDecimal = validateMaxTwoDecimal(value.replaceAll('.', ','))
    return valueDecimal
}

export function transformToId(string) {
    return string.replace(/[ ,]/g, '_').toUpperCase()
}

// check if a value is invalid.
// if the value is an object or array, it is recursed
// if the object or array has just one invalid value,
// the entire object is considered invalid
export const checkInvalidValueDeep = value => {
    if (_.isObjectLike(value)) {
        return _.values(value).some(checkInvalidValueDeep) || _.isEmpty(value)
    } else {
        return _.isNil(value) || value === ''
    }
}

// check if a value is valid.
// if the value is an object or array, it is recursed
// if the object or array has just one invalid value,
// the entire object is considered invalid
export const checkValidValueDeep = value => {
    if (_.isObjectLike(value)) {
        return !(_.values(value).some(checkValidValueDeep) || _.isEmpty(value))
    } else {
        return !(_.isNil(value) || value === '')
    }
}

export function difference(data, base) {
    function changes(auxData, auxBase) {
        return _.transform(auxData, function(result, value, key) {
            if (!_.isEqual(value, auxBase[key])) {
                result[key] =
                    _.isObject(value) && _.isObject(auxBase[key])
                        ? changes(value, auxBase[key])
                        : value
            }
        })
    }
    return changes(data, base)
}

export function deepFreeze(obj) {
    Object.freeze(obj)
    Object.getOwnPropertyNames(obj).forEach(prop => {
        if (
            !!obj[prop] &&
            typeof obj[prop] === 'object' &&
            !Object.isFrozen(obj[prop])
        ) {
            deepFreeze(obj[prop])
        }
    })
    return obj
}

export function encodeImageUrl(partialUrl) {
    return `${REACT_APP_IMG}/${encodeURIComponent(partialUrl)}`
}

export function checkIsMobile() {
    return (
        navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/BlackBerry/i) ||
        navigator.userAgent.match(/Windows Phone/i)
    )
}

export function useIsMobile() {
    // added 2025-01-27 noSrr: true this because first render is false https://v5.mui.com/material-ui/react-use-media-query/#client-side-only-rendering
    // https://stackoverflow.com/questions/68497916/material-ui-usemediaquery-not-initially-recognising-correct-breakpoint
    return useMediaQuery(`(max-width: ${breakpoints.mobileMax}px)`, {noSsr: true})
}

export const checkValidEmail = elem => {
    const r = RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
    return r.test(elem)
}

export const checkValidPhone = elem => {
    const r = RegExp(/^([1-9][0-9]{0,})$/)
    return r.test(elem)
}

export const checkValidPhoneLength = elem => {
    const r = RegExp(/^([1-9][0-9]{9})$/)

    return r.test(elem)
}


export const validPhoneWhatsApp = value => {
    const digitsOnly = String(value ?? '').replace(/\D/g, '')
    const regex = RegExp(/^(?:(?:00)?549?)?[^0]?(?:11|[2368]\d)(?:(?=\d{0,2}^(15))\d{2})??\d{8}$/)
    return regex.test(digitsOnly)
}

export const testRegex = (regex, value) => {
    return regex.test(value)
}

export const checkValidCuitLength = value =>{
    const r = RegExp(/^([0-9]{11}|[0-9]{2}-[0-9]{8}-[0-9]{1})$/)
    return r.test(value)
}
 
export const checkOnlyText = (elem, allowSpaces = true) => {
    let regexPattern = '^[A-Za-zÁáÉéÍíÓóÚúÑñ]+$'; // Expresión regular sin espacios por defecto
    if (allowSpaces) {
      regexPattern = '^[A-Za-zÁáÉéÍíÓóÚúÑñ ]+$'; // Expresión regular con espacios 
    }
    return RegExp(regexPattern, 'i').test(elem);
}

export const checkWithoutSymbolAndNumbers = value => {
    const regex =  RegExp(/^[^$`^%&".,¿¡#)(:=;}°*~¬/{¨[_!?|<>#0-9]+$/)
    return regex.test(value)
}

export const checkHasMoreThanTwoCharacters = elem =>{
    return elem?.length > 2
}

export const isOnlyNumber = ({ value, commas = false, dots = false }) => {
    if (!value) return

    let basicRegex = RegExp(/^[0-9]+$/)
    if (commas) {
        basicRegex = RegExp(/^[,0-9]+$/)
    } else if (dots) {
        basicRegex = RegExp(/^[.0-9]+$/)
    }

    const rgNum = new RegExp(basicRegex)
    return rgNum.test(value)
}

export const handleInputOnlyNumber = (event, setValue) => {
    const {
        target: { value: valueToSet }
    } = event
    if (!valueToSet || isOnlyNumber({ value: valueToSet })) {
        setValue(Number(valueToSet))
    }
}

export const containsNumbers = ({ value }) => {
    if (!value) return
    let basicRegex = /[0-9]/
    const rgNum = new RegExp(basicRegex)
    return rgNum.test(value)
}

export const alLeastOneCapitalLetter = (value) =>{
    if (!value) return
    const basicRegex = /(?=.*[A-Z])/
    const rgNum = new RegExp(basicRegex)
    return rgNum.test(value)
}

export const atLeastOneNumber = ( value ) =>{
    if (!value) return
    const basicRegex = /(?=.*[0-9])/
    const rgNum = new RegExp(basicRegex)
    return rgNum.test(value)
}

export const checkValidDni = ( value ) => {
    if(!value) return 
    const basicRegex = /^[\d]{1,2}[\d]{3,3}[\d]{3,3}$/
    const rgNum = new RegExp(basicRegex)
    return rgNum.test(value)
}
 
export const QS_CONFIG_ARRAY = {
    arrayFormat: 'bracket',
    encode: false,
    skipNull: true,
    skipEmptyString: true
}

export const QS_CONFIG = {
    arrayFormat: 'none',
    encode: false,
    skipNull: true,
    skipEmptyString: true
}

export const QS_CONFIG_ARRAY_ENCODED = {
    arrayFormat: 'bracket',
    encode: true,
    skipNull: true,
    skipEmptyString: true
}

export const textTransform = (value, transform) => {
    if (!value || typeof value !== 'string') return
    switch (transform) {
        case 'MAYUS':
            return value.toUpperCase()
        case 'MINUS':
            return value.toLowerCase()
        default:
            return value
    }
}

export const moneyMask = money => {
    return money.toLocaleString(currentLocale)
}

export const checkDatafieldMatch = (str, word) => {
    return str.split(',').some(field => field === word)
}

export const separateSortField = sort => {
    if (sort) {
        return sort.startsWith('-') ? sort.slice(1) : sort
    }
    return sort
}

export const flatArrayOfOne = arr => {
    return arr.length > 1 ? arr : arr[0]
}

export function toggleCsvValue(csv = '', value) {
    if (csv.includes(value)) {
        return csv
            .split(',')
            .filter(e => e !== value)
            .filter(e => e) // sacar valores vacíos
            .join(',')
    } else {
        return csv
            .split(',')
            .concat(value)
            .filter(e => e) // sacar valores vacíos
            .join(',')
    }
}

export function historyReturn(history, location, slug) {
    const from = location.state?.from
    if (from?.pathname.includes(slug)) {
        history.push({
            ...location,
            pathname: from.pathname,
            search: from.search,
            state: from.state
        })
    } else {
        history.push({
            ...location,
            pathname: slug,
            search: undefined
        })
    }
}

export function formatToastsFromArray(arr, extraOptions = {}) {
    if (typeof arr === 'string') {
        return { title: arr }
    }
    if (Array.isArray(arr)) {
        return {
            title: (
                <ul>
                    {arr.map(msg => (
                        <li key={msg}>{msg}</li>
                    ))}
                </ul>
            ),
            ...extraOptions
        }
    }
}

export function updateBreadcrumbs(id, data, history) {
    const locationState = history.location.state || {}
    const search = history.location.search || location.search || ''
    const breadCrumbs = locationState.breadcrumbs || {}
    history.replace({
        state: {
            ...locationState,
            breadcrumbs: {
                ...breadCrumbs,
                [id]: data
            }
        },
        search,
    })
}

export function closeReactSelectMenu(ref) {
    if (ref.current?.state?.menuIsOpen === true) {
        ref.current.setState({ menuIsOpen: false })
        ref.current.select.setState({ isFocused: false })
    }
}

export function roundLowEpsilon(n) {
    const rounded = Math.round(n)
    if (Math.abs(rounded - n) < 1e-5) {
        return rounded
    }
    return n
}

export function castNumbersInObj(obj = {}, props = []) {
    props.forEach(prop => {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(prop) && !isNaN(obj[prop])) {
            obj[prop] = Number(obj[prop])
        }
    })
}

export const cleanFormatAndReturnNumber = value => {
    if(!value) return null
    const cleanNumber = value.replaceAll('.', '')
    const intValue = parseInt(cleanNumber)
    if (!isNaN(intValue) || cleanNumber === '') {
        return intValue
    }
}

export const validatePercentage = value => {
    if(!value) return null
    const parsedValue = parseInt(value, 10)
    if (isNaN(parsedValue)) return null
    if (parsedValue > 100) return 100
    if (parsedValue < 1) return 1
    return parsedValue
}

export function getRankDiscount(bonifications, saleQuantity = 1) {
    for (let i = 1; i <= 5; i++) {
        const rankFrom = bonifications['rank' + i + '_from']
        const rankTo = bonifications['rank' + i + '_to']
        if (
            rankFrom <= saleQuantity &&
            (rankTo >= saleQuantity || rankTo === null)
        ) {
            return bonifications['rank' + i + '_amount']
        }
    }
    return 0
}

export const checkHasThreeCharacters = elem =>{
    return elem.length >= 3
}

//This function formats the pricing rules discount to the required format ex: N15U10
// El catalogo debe tener adentro un objeto bonification. El carLotId y saleType se usan para seleccionar el Descuento por Perfil (si es que tienen).
// TODO: Documentar funcion
export function calculateDiscounts({
    catalog = {},
    profileDiscounts = [],
    carLotId,
    saleType,
    saleQuantity = null,
    remainder = null,
    permissions = null
}) {
    const checkPermissionForBonifications = checkPermission(
        PERMISSIONS_MODULES_ACRONYMS.Presupuestador.function
            .CargaManualBonificaciones.acronym,
        permissions
    )
    let maxDiscount = 0
    let usedDiscount = 0
    const {
        discount_amount,
        discount_valid_to,
        discount_sales_valid,
        specific_amount,
        specific_valid_to,
        taking_car_percentage,
        taking_car_valid_to,
        ranks_valid_to,
        taking_car_sales_valid,
        car_lot_amount,
        car_lot_sales_from_date,
    } = catalog?.bonification || {}
    const validToSpecificDiscount = moment(specific_valid_to)
    const validToTakingCar = moment(taking_car_valid_to)
    const validToDiscount = moment(discount_valid_to)
    const ranksValidTo = moment(ranks_valid_to)
    const carLotSalesFromDate = moment(car_lot_sales_from_date)
    const today = moment().startOf('day')
    const profileDiscount =
        profileDiscounts.find(
            discount =>
                discount.car_lot_id === carLotId &&
                discount.sale_type === saleType
        )?.value || 0
    const profileDiscountAmount =
        carLotSalesFromDate >= today || car_lot_sales_from_date === null
            ? (profileDiscount *
                  (catalog?.precio_local - (car_lot_amount || 0))) /
                  100 || 0
            : 0
    const specificDiscount =
        (validToSpecificDiscount >= today || specific_valid_to === null) &&
        specific_amount
            ? specific_amount
            : 0
    const discountAmount =
        (validToDiscount >= today || discount_valid_to === null) &&
        discount_sales_valid &&
        discount_amount
            ? discount_amount
            : 0
    const rankDiscount =
        ranksValidTo >= today || ranks_valid_to === null
            ? getRankDiscount(catalog?.bonification || {}, saleQuantity)
            : 0
    const takingCarPercentage =
        (validToTakingCar >= today || taking_car_valid_to === null) &&
        taking_car_sales_valid &&
        taking_car_percentage
            ? taking_car_percentage
            : 0
    if (checkPermissionForBonifications) {
        usedDiscount = 0
        maxDiscount = 0
        remainder = 0
        return { usedDiscount, maxDiscount, remainder }
    }
    switch (saleType) {
        case SALE_TYPE.CONVENTIONAL:
            usedDiscount = takingCarPercentage
            maxDiscount =
                specificDiscount + profileDiscountAmount + discountAmount
            break
        case SALE_TYPE.DIRECT:
            usedDiscount = 0
            maxDiscount = profileDiscountAmount + rankDiscount
            break
        case SALE_TYPE.USED:
            usedDiscount = takingCarPercentage
            maxDiscount = specificDiscount + profileDiscountAmount
            break
        default:
            break
    }

    return { usedDiscount, maxDiscount, remainder }
}

/**
 * Recalcula N/U de una solicitud/venta con la misma lógica que presupuestador.
 * Usa Bonifications / Role_bonifications congelados; fallback a discounts_pill.
 */
export function calculateMaximoDescuentoFromSale(sale, { permissions = null } = {}) {
    const fallback = {
        monto: sale?.discounts_pill?.N || 0,
        porcentaje: sale?.discounts_pill?.U || 0,
        remainder: 0,
    }
    if (!sale) return fallback

    const saleType =
        sale.sale_type === 'USADO' ? SALE_TYPE.USED : sale.sale_type
    if (!saleType) return fallback

    let bonification = { ...(sale.Bonifications || sale.auto?.bonification || {}) }
    if (
        !sale.Bonifications &&
        !sale.Role_bonifications &&
        !sale.auto?.bonification
    ) {
        return fallback
    }

    // Bonificaciones congeladas: no vencen por fecha (igual que loadItemNuevo con datos_frizados)
    if (sale.Bonifications) {
        bonification.specific_valid_to = null
        bonification.discount_valid_to = null
        bonification.ranks_valid_to = null
        bonification.taking_car_valid_to = null
        bonification.car_lot_valid_to = null
    }

    if (saleType === SALE_TYPE.DIRECT) {
        bonification = {
            ...bonification,
            car_lot_amount_friz: bonification.car_lot_amount,
            car_lot_amount: null,
        }
    }

    if (
        sale.stock_id &&
        saleType === SALE_TYPE.CONVENTIONAL &&
        sale.auto?.Stocks?.length
    ) {
        const stock = sale.auto.Stocks.find(s => s.id === sale.stock_id)
        if (stock?.Bonification) {
            bonification = {
                ...bonification,
                specific_amount: stock.Bonification.specific_amount,
                specific_valid_to: sale.Bonifications
                    ? null
                    : stock.Bonification.specific_valid_to,
            }
        }
    }

    const profileDiscounts = sale.Role_bonifications
        ? [
              {
                  id: sale.Role_bonifications.role_id || null,
                  car_lot_id:
                      sale.Role_bonifications.role_car_lot_id ||
                      sale.car_lot_id ||
                      null,
                  sale_type:
                      sale.Role_bonifications.role_sale_type || saleType,
                  value: sale.Role_bonifications.role_value || null,
              },
          ]
        : []

    const catalog = {
        ...(sale.auto || {}),
        precio_local:
            sale.auto?.precio_local ?? sale.catalog_net_sale_price,
        bonification,
    }

    const { maxDiscount, usedDiscount } = calculateDiscounts({
        catalog,
        profileDiscounts,
        carLotId: sale.car_lot_id,
        saleType,
        saleQuantity: sale.sale_quantity || null,
        permissions,
    })

    return {
        monto: maxDiscount,
        porcentaje: usedDiscount,
        remainder: 0,
    }
}

// TODO: Documentar funcion
export function formatPricingDiscounts({
    usedDiscount = 0,
    maxDiscount = 0,
    remainder = null
}) {
    const showRemainder =
        remainder !== null && `R${Math.floor(remainder / 1000)}`
    let textDiscounts = `N${Math.floor(maxDiscount / 1000)}U${Math.floor(
        usedDiscount
    )}`

    if (remainder || remainder === 0) {
        textDiscounts = `${textDiscounts}${showRemainder}`
    }

    return textDiscounts
}

export function formatTakingCarPricingDiscount({
    usedDiscountPercentage = 0,
    takePrice,
    permissions = null
}) {
    const checkPermissionForBonifications = checkPermission(
        PERMISSIONS_MODULES_ACRONYMS.Presupuestador.function
            .CargaManualBonificaciones.acronym,
        permissions
    )
    if (checkPermissionForBonifications) {
        return 0
    }
    const discountNominalValue =
        Math.floor(takePrice * usedDiscountPercentage) / 100
    return Math.floor(discountNominalValue / 1000)
}

export function daysDiff(firstDate, secondDate) {
    const a = moment(firstDate)
    const b = moment(secondDate)

    return Math.abs(a.diff(b, 'days'))
}

export function carImageNotFound(event) {
    event.target.src = imageCarNotFound
    event.target.classList.add('car-image-not-found')
}

export const carNotFoundImage = encodeImageUrl(CAR_NOT_FOUND_THUMB)

export const calculateRemainder = ({
    discountNewVehicle,
    specialDiscount,
    discountUsedVehicle,
    takingCars = [],
    saleQuantity = 1
}) => {
    let calculateUsed = 0
    //Calculo de la bonificacion del usado si es negativo se lo resto al remainder
    takingCars.forEach(item => {
        const maxValueDiscount = item.updatedTakePrice
            ? item.updatedTakePrice * (discountUsedVehicle / 100)
            : item.original_price * (discountUsedVehicle / 100)
        const bonification = maxValueDiscount - item.take_improvement_amount
        if (bonification < 0) {
            calculateUsed = calculateUsed + bonification
        }
    })

    let remainder = Number(discountNewVehicle)

    //Calculo en nuevo
    if (specialDiscount >= 0) {
        remainder = (remainder - Number(specialDiscount)) * Number(saleQuantity)
    }

    //Calculo el usado
    remainder = remainder + calculateUsed

    return remainder > 0 ? remainder : 0
}
// Cálculo del precio de venta de vehiculo usado
export const calculateSalePrice = (
    precio_lista = 0,
    accessory1 = 0,
    accessory2 = 0
) => {
    const salePriceVehiculoUsado = Number(
        precio_lista + accessory1 + accessory2
    )

    return salePriceVehiculoUsado
}
// Cálculo del margen de venta de vehiculo usado
export const calculateMargin = (
    sale_price = 0,
    costo_compra = 0,
    flete_alistaje = 0
) => {
    const marginVehiculoUsado = Number(
        sale_price - costo_compra - flete_alistaje
    )
    return sale_price !== 0 ? marginVehiculoUsado : 0
}
// Cálculo del margen de venta como porcentaje del precio de venta
export const calculateMarginPercentage = (margin, sale_price = 0) => {
    const marginPercentage = Number(margin / sale_price) * 100
    const percentageUnrounded = Math.floor(marginPercentage * 100) / 100
    return sale_price !== 0 ? percentageUnrounded.toFixed(2) : 0
}

export const debouncePromise = (inner, ms = 0) => {
    let timer = null
    let resolves = []
    return function(...args) {
        // Run the function after a certain amount of time
        clearTimeout(timer)
        timer = setTimeout(() => {
            // Get the result of the inner function, then apply it to the resolve function of
            // each promise that has been created since the last time the inner function was run
            let result = inner(...args)
            resolves.forEach(r => r(result))
            resolves = []
        }, ms)
        return new Promise(r => resolves.push(r))
    }
}
function padTo2Digits(num) {
    return num.toString().padStart(2, '0')
}

//formatear fecha a DD/MM/YYY
export function getFormatDate(initialDate) {
    const date = new Date(initialDate)
    return [padTo2Digits(date.getDate()), padTo2Digits(date.getMonth() + 1), date.getFullYear()].join('/')
}

export const settingMomentES = () => {
    moment.lang('es', {
        months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Feb_Mar_Abr_May_Jun_Jul_Ago_Sep_Oct_Nov_Dic'.split(
            '_'
        ),
        weekdays: 'Domingo_Lunes_Martes_Miércoles_Jueves_Viernes_Sábado'.split(
            '_'
        ),
        weekdaysShort: 'Dom_Lun_Mar_Mié_Jue_Vie_Sáb.'.split('_'),
        weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sá'.split('_')
      })
      moment.locale('es')
}


export function getCustomFormatDate(date, format) {
    const dateFormat = moment(date)
    settingMomentES()
    return dateFormat.format(format)
}

export function formatDate(date = null, inv = false) {
    if (!inv) {
        const fullDate = date ? new Date(date) : new Date()
        const year = fullDate.getFullYear()
        const month = fullDate.getMonth() + 1
        const monthFormatted = month < 10 ? `0${month}` : month
        return year + monthFormatted
    } else {
        const yearFromDate = date?.slice(0, 4)
        const monthFromDate = date?.slice(4, 6)
        const currentDate = new Date()
        currentDate.setFullYear(Number(yearFromDate))
        currentDate.setDate(1)
        currentDate.setMonth(Number(monthFromDate) - 1)
        return currentDate
    }
}

export function getAsofixSAS() {
    return JSON.parse(localStorage.getItem('isAsofixSAS'))
}

export function capitalizeText(text) {
    if (typeof text !== 'string') {
        return text
    }
    const lowerText = text.toLowerCase()
    return lowerText.charAt(0).toUpperCase() + lowerText.slice(1)
}

export const validateDecimal = function(value, minValue) {
    if (value >= minValue && value <= MAX_SHAREVALUE) {
        const newValueValidate =
            value.indexOf('.') >= 0
                ? value.substr(0, value.indexOf('.')).substr(0, 4) +
                  value.substr(value.indexOf('.'), 3)
                : value

        return { valueValidate: newValueValidate, error: false }
    }
    return {
        valueValidate: value < minValue ? '' : MAX_SHAREVALUE,
        error: true
    }
}

export const validateMaxTwoDecimal = value => {
    const newValueValidate =
        value.indexOf(',') >= 0
            ? value.substr(0, value.indexOf(',')) +
              value.substr(value.indexOf(','), 3)
            : value

    return newValueValidate
}

export const validateMaxOneDecimal = value => {
    value = value.replace('.', ',')
    const newValueValidate =
    value.indexOf(',') >= 0
    ? value.substr(0, value.indexOf(',')) +
    value.substr(value.indexOf(','), 2)
    : value

    return newValueValidate
}

export const truncateToDecimal = (number, decimalPlaces) => {
    if(number === null) return null
    if(typeof number === 'string'){
        number = +number.replace(',','.')
    }
    const factor = 10 ** decimalPlaces;
    return Math.trunc(number * factor) / factor;
  }

export const getFullOrMiniImage = (image, type) => {
    const imageSubstrBefore = image.substr(0, image.indexOf('/products/'))
    const imageImageSubstrAfter = image.substr(image.indexOf('/products/'))
    const typeImage = type === 'mini' ? 'mini' : 'th'
    return `${imageSubstrBefore}/products/${typeImage}-${imageImageSubstrAfter.substr(
        10
    )}`
}

export const removeAccents = str =>
    str?.normalize('NFD')?.replace(/[\u0300-\u036f]/g, '') || ''

export const isOnlyNumbers = value => {
    // eslint-disable-next-line no-useless-escape
    const rgNum = new RegExp(
        /^([0-9]\d*(\.|,)\d*|0?(\.|,)\d*[0-9]\d*|[0-9]\d*)$/gm
    )
    return rgNum.test(value)
}

export const removeLeadingZeros = value => {
    return value.length === 2 && value[0] === '0' && value[1] === '0'
}

export const getCalculationAmountPercentage = (operator, value, salePrice) => {
    let amountCalculation = 0
    let percentageCalculation = 0
    if (operator === '%') {
        percentageCalculation = getValueAmount(
            formatNumber.resetPercentSign(value)
        )
        amountCalculation = salePrice
            ? (Number(percentageCalculation) * Number(salePrice)) / 100
            : null
    } else {
        amountCalculation = formatNumber.resetMoneySign(getValueAmount(value))
        percentageCalculation = salePrice
            ? (formatNumber.resetMoneySign(getValueAmount(value)) /
                  Number(salePrice)) *
              100
            : null
    }

    return { amountCalculation, percentageCalculation }
}

export const getValueAmount = value => {
    return value === '' ? 0 : value
}

export const getMultiSelectQuery = (
    elements = [],
    key = ''
) => {
    let query = ''

    elements.forEach(element => {
        if(element.id) {
            element.id.forEach(item => {
                query = !query ? `${item}` : query + `&${key}=${item}`
            })
        } else if(element.value) {
            element.value.forEach(item => {
                query = !query ? `${item.value}` : query + `&${key}=${item.value}`
            })
        }
    })
    return query
}

// eslint-disable-next-line no-useless-escape
const regexToDetectUrls = /(http|https)?(:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{2,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g
export const extractLinks = text => {
    if (regexToDetectUrls.test(text)) {
        const [link] = text.match(regexToDetectUrls)
        let hrefLink = link
        if (hrefLink.indexOf('http') < 0) {
            hrefLink = 'http://' + hrefLink
        }
        const indexToCute = text.indexOf(link)
        const indexTofinish = indexToCute + link.length
        if (indexToCute > 0) {
            const firstElement = text.substring(0, indexToCute)
            const linkElement = (
                <a
                    href={hrefLink}
                    rel="noreferrer"
                    className="hyperlink-container"
                    target="_blank"
                >
                    {link}
                </a>
            )
            const restOfTheText = text.substring(indexTofinish)
            return [firstElement, linkElement, ...extractLinks(restOfTheText)]
        } else {
            const linkElement = (
                <a
                    href={hrefLink}
                    rel="noreferrer"
                    className="hyperlink-container"
                    target="_blank"
                >
                    {link}
                </a>
            )
            const restOfTheText = text.substring(indexTofinish)
            return [linkElement, ...extractLinks(restOfTheText)]
        }
    } else {
        return [text]
    }
}

export const getQueryByArray = ({
    key,
    array = [],
    replaceFirstKey = false
}) => {
    const keyToQuery = key.replace('[]', '')
    let query = qs.stringify(
        { [keyToQuery]: array },
        { arrayFormat: 'bracket' }
    )
    if (replaceFirstKey) {
        let keyToReplace = key
        if (keyToReplace.indexOf('[]') === -1) {
            keyToReplace += '[]'
        }
        return query.replace(`${keyToReplace}=`, '')
    }
    return query
}

export const getMaxMinValue = (array, ref = 'value', max = true) => {
    return array.reduce((prev, next) => {
        if (max && next[ref] >= prev) return next[ref]
        if (!max && next[ref] <= prev) return next[ref]
        return prev
    }, 0)
}

export const selectStylesAbmDropdown = {
    option: style => ({
        ...style,
        textOverflow: 'ellipsis',
        overflow: 'hidden'
    })
}

export const breakpoints = {
    tabletMinPortrait: 640,
    tabletMinLandscape: 1024,
    desktopMin: 1280,
    mobileMax: 639,
    tabletMaxPortrait: 1023,
    tabletMaxLandscape: 1279,
    mobileFirst: 412,
    mobileLast: 360
}

export const getBestFinancingLine = (lines, factoryPrice, referencePrice) => {
    let financingLines = [];
    lines.forEach(financingLine => {
        const subLines = financingLine.lines.map(line => {
            const maxAmountWithFactoryPrice = (line.porcMaxFinance / 100) * factoryPrice
            const maxAmountWithoutFactoryPrice = (referencePrice * 1000 * line.porcMaxFinance) / 100
            const maxAmount = factoryPrice ? maxAmountWithFactoryPrice : maxAmountWithoutFactoryPrice
            return {
                bank: financingLine.bank,
                name: financingLine.name,
                monthsTerm: line.quantity,
                tna: line.tna,
                tipoTasa: financingLine.tipoTasa,
                maximumAmount: maxAmount < line.capMax ? maxAmount : line.capMax,
                exceedFinanceLimit: financingLine.exceedFinanceLimit
        }})
        financingLines = financingLines.concat(subLines);
    })
    // Ordena por TNA y por monto maximo a financiar; retorna la linea con el menor TNA.
    // Si hay mas de una con el mismo TNA, retorna la que tenga el mayor monto a financiar.
    // Si los montos tambien son iguales, retorna la primera del array.
    return  _.orderBy(financingLines, ['tna', 'maximumAmount'], ['asc', 'desc'])[0]
}

export const filterImages = img => img.type.name.includes('image/')

export const formatImages = img => ({
    id: _.uniqueId(),
    src: encodeImageUrl(img.url || img.mini_url || img.thumbnail_url),
    selected: true,
    comesDefault: true
})

export const getCarDealershipLogo = files =>
    files.find(file => file.type.extension !== "application/pdf")?.url || ''

export const checkConditionAndRedirect = (history, condition, redirectPath) => {
    if (!condition) {
        history.push(redirectPath);
    }
}

export const formatPercentage = {
    depreciation: (value) => String(value).replace('.',','),
    table: (value) => String(value).replace('-','').replace('.',',')
}
export const pluralize = (
    minSelectors = 1,
    baseWord = '',
    pluralSuffix = '',
    singularSuffix = '',
) => `${baseWord}${minSelectors === 1 ? singularSuffix : pluralSuffix}`;

export const b64toBlob = (base64Data, contentType = '', sliceSize = 512) => {
    try {
      const byteCharacters = atob(base64Data);
      const byteArrays = Array.from(byteCharacters).map((char, index) => {
        return byteCharacters.charCodeAt(index);
      });
  
      const chunkedArrays = [];
      for (let i = 0; i < byteArrays.length; i += sliceSize) {
        const chunk = byteArrays.slice(i, i + sliceSize);
        const byteArray = new Uint8Array(chunk);
        chunkedArrays.push(byteArray);
      }
  
      const blob = new Blob(chunkedArrays, { type: contentType });
      return blob;
    } catch (error) {
      console.error('Error converting base64 to Blob:', error);
      return null;
    }
  }

export const XML_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export const fileSizeInMB = size => (size / (1024 * 1024)).toFixed(2) + 'MB'

export const validateVin = (vin) => {
    const regexp = /^[a-zA-Z0-9ñÑ]{17,17}$/
    return regexp.test(vin)
}

export const createFileURL = file =>
file.url ? `${REACT_APP_IMG}/${encodeURIComponent(file.url)}` : URL.createObjectURL(file.file)

export const formatDateUtc = (
    date = new Date(),
    dateFormat = 'DD/MM/YYYY'
) => moment(date).utc().local().format(dateFormat)

export const formatDateUtcWithoutLocal = (
    date = new Date(),
    dateFormat = 'DD/MM/YYYY'
) => moment(date).utc().format(dateFormat)

/**
 *	@description delete the protocol from a URL
 *	@param { string } link - URL to modify
 *	@returns { string } - URl without protocol
 */
export const removeProtocol = (link) => {
    return link.replace(/^(https?|ftp):\/\//, '');
}

export const getExceedFinanceLimitLegend = (exceedFinanceLimit) =>{
    return exceedFinanceLimit ? '(sin límite máximo)' : ''
}

const ARGENTINA_COUNTRY_PHONE_CODE = '54'

export const getPhoneWhatsappFormatted = (phone, countryCode) => {
    const phoneLengthWithoutCountryCode = 10
    const digitsOnly = String(phone ?? '').replace(/\D/g, '')

    if (!digitsOnly)
        throw new Error('phone cannot be empty')

    if (digitsOnly.length < phoneLengthWithoutCountryCode)
        throw new Error('phone length is too short')

    if (digitsOnly.length === phoneLengthWithoutCountryCode)
        return `${countryCode}${digitsOnly}`

    return digitsOnly
}

export const openWhatsapp = (phone, text = '', countryCode = ARGENTINA_COUNTRY_PHONE_CODE) => {
    const WHATSAPP_URL = 'https://wa.me/'
    const phoneFormatted = getPhoneWhatsappFormatted(phone, countryCode)

    const url = new URL(WHATSAPP_URL)
    url.pathname = phoneFormatted
    if (text) url.searchParams.append('text', text)

    // docs https://faq.whatsapp.com/5913398998672934/?helpref=uf_share
    window.open(url.href)
}

export const numberStartWithZero = (value) =>{
    if (!value) return
    const basicRegex = /^0[0-9]*$/
    const rgNum = new RegExp(basicRegex)
    return rgNum.test(value)
}

export const capitalizeEachWord = (str) => {
    if (!str) {
        return '';
    }
    const words = str.split(' ')
    const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1))
    return capitalizedWords.join(' ')
}

export const getMeliTokenExpirationStatus = (expirationDate, tokenExpired) => {
    if (tokenExpired) {
        return {
            isTokenExpired: true,
            isTokenAboutToExpire: true
        }
    }
    const now = moment().startOf('day');
    const expiration = moment(expirationDate).startOf('day');
    const diff = now.diff(expiration, 'days')
    // token vencido
    const isTokenExpired = diff > 0
    // token que vence en 15 o menos días
    const isTokenAboutToExpire = diff >= (MELI_DAYS_UNTIL_REFRESH_TOKEN * -1)
    return {
        isTokenExpired, isTokenAboutToExpire
    }
}

export const isIphone = () => {
    if (typeof window !== 'undefined' && window.navigator) {
      return /iPhone|iPad|iPod/i.test(window.navigator.userAgent)
    }
    return false
}

export const cleanLocalStorage = (key) => {
    try { localStorage.removeItem(key) }
    catch (e) { console.error('No se pudo limpiar el storage', e) }
}

export const closeModalAndClean = (key, hash, goBack) => {
    cleanLocalStorage(key)
    if (window.location.hash === hash) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search)
    }
    if (goBack) window.history.back()
}

export const clearURL = () => {
    window.history.replaceState(null, ' ', window.location.pathname + window.location.search)
}

// Redondea valores de CFT según la regla de negocio
export const roundCFT = (valor) => {
    const numero = Number(valor);

    if (!isFinite(numero)) return '-'; //valida contra null, undefined, NaN, string vacío, etc.

    const entero = Math.floor(numero);
    const decimal = numero - entero;

    return decimal > 0.5999 ? entero + 1 : entero;
  };

export const formatRatioAsPercentage = (value, total) => {
    if (!total || total === 0) return '0%'
    return `${Math.round((value / total) * 100)}%`
}
